import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AddIllustration from './components/admin/AddIllustration.jsx';
import { EditIllustration } from './components/admin/EditIllustration';
import Footer from './components/common/Footer.jsx';
import Navbar from './components/common/Navbar.jsx';
import WelcomePage from './components/common/WelcomePage.jsx';
import WorkInProgress from './components/common/WorkInProgress.jsx';
import ContactMe from './components/form/ContactMe.jsx';
import Page from './components/navigation/Page.jsx';
import { CartProvider } from './context/cart/CartProvider.jsx';
import { useFetchIllustrations } from './hooks/useFetchIllustrations.js';
import AboutPage from './pages/AboutPage';
import HomePage from './pages/HomePage';
import ItemDetailsPage from './pages/ItemDetailsPage.jsx';
import LogInPage from './pages/LoginPage.jsx';
import NotFoundPage from './pages/NotFoundPage';
import SignUpPage from './pages/SignUpPage.jsx';

export function onRenderCallback(
  id, // the "id" prop of the Profiler tree that has just committed
  phase, // either "mount" (if the tree just mounted) or "update" (if it re-rendered)
  actualDuration, // time spent rendering the committed update
  baseDuration, // estimated time to render the entire subtree without memoization
  startTime, // when React began rendering this update
  commitTime, // when React committed this update
  interactions // the Set of interactions belonging to this update
) {
  console.log("id and actuallDuration", actualDuration)
}
const App = () => {
  const [illustrations, isLoading] = useFetchIllustrations();

  if (isLoading && illustrations.length !== null) {
    return <WelcomePage isLoading={isLoading} />;
  }



  return (
    <>
      <div>
        <div className="flex flex-col h-screen justify-between">
          <CartProvider>
            <BrowserRouter>
              <div>
                <Navbar />
                <Routes>
                  <Route

                    path="/"
                    element={
                      <Page>
                        <HomePage />
                      </Page>
                    }
                  />
                  <Route
                    path="/shop"
                    element={
                      <Page>
                        <WorkInProgress />
                      </Page>
                    }
                  />
                  <Route
                    path="/about"
                    element={
                      <Page>
                        <AboutPage />
                      </Page>
                    }
                  />
                  <Route
                    path="/contact"
                    element={
                      <Page>
                        <ContactMe />
                      </Page>
                    }
                  />

                  <Route
                    path="/login"
                    element={
                      <Page>
                        <LogInPage />
                      </Page>
                    }
                  />
                  <Route
                    path="/signUp"
                    element={
                      <Page>
                        <SignUpPage />
                      </Page>
                    }
                  />
                  {/*
                    <Route
                      path="/admin"
                      element={
                        <Page>
                          <ProtectedRoute>
                            <AdminPage />
                          </ProtectedRoute>
                        </Page>
                      }
                    />
                    
                     */}

                  <Route
                    path="/add"
                    element={
                      <Page>
                        <AddIllustration />
                      </Page>
                    }
                  />
                  <Route
                    path="/edit/:editId"
                    element={
                      <Page>
                        <EditIllustration />
                      </Page>
                    }
                  />
                  <Route
                    path="/illustrations/:_illustrationId"
                    element={<ItemDetailsPage />}
                  />
                  <Route
                    path="*"
                    element={
                      <Page>
                        <NotFoundPage />
                      </Page>
                    }
                  />
                </Routes>
              </div>
              <Footer />
            </BrowserRouter>
          </CartProvider>
        </div>
      </div>
    </>
  );
};

export default App;
